import { render, staticRenderFns } from "./CommentForm.vue?vue&type=template&id=44840955&scoped=true"
import script from "./CommentForm.vue?vue&type=script&lang=ts"
export * from "./CommentForm.vue?vue&type=script&lang=ts"
import style0 from "./CommentForm.vue?vue&type=style&index=0&id=44840955&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44840955",
  null
  
)

export default component.exports